function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 1a3.34 3.34 0 00-4.7 0L1.13 14.14a.7.7 0 00-.18.34L0 19.18a.66.66 0 00.53.82.61.61 0 00.27 0l4.7-1a.7.7 0 00.34-.18L19 5.67A3.33 3.33 0 0019 1zM2.55 14.61L12 5.2 14.77 8l-9.4 9.41zM12.89 4.26l.47-.47 2.82 2.82-.47.47zM2 16l2 2-2.51.5zM18 4.77l-.94.94-2.76-2.86.94-.94a2 2 0 012.82 2.82z",
  fill: "#fff"
});

var SvgPencil = function SvgPencil(props) {
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default SvgPencil;